import type IDetailRow from '@components/RatingTable/components/ProductPopup/interfaces/IDetailRow';

import type IGroupDetailRow from '../interfaces/IGroupDetailRow';

const DEFAULT_COUNT = 3;
export const groupDetails = (data: IDetailRow[], count = DEFAULT_COUNT): IGroupDetailRow[] => {
  const sortedData = [].concat(
    ...Object.values(
      data.reduce((acc, item, index) => {
        if (typeof item.value === 'string') {
          if (acc[item.value]) {
            acc[item.value].values.push(item);
          } else {
            acc[item.value] = { values: [item], position: index };
          }
        } else {
          acc[index] = { values: [item], position: index };
        }

        return acc;
      }, {} as Record<string, { values: IDetailRow[]; position: number }>),
    )
      .sort((a, b) => a.position - b.position)
      .map((item) => item.values),
  );
  const out = [];

  for (let i = 0; i < sortedData.length; i++) {
    const batch = [sortedData[i]];

    for (let j = i + 1; j < sortedData.length; j++, i++) {
      if (sortedData[i].value === sortedData[j].value && !sortedData[i].valueTooltip && !sortedData[j].valueTooltip) {
        batch.push(sortedData[j]);
      } else {
        break;
      }
    }

    if (batch.length < count) {
      out.push(
        ...batch.map((x) => ({
          labels: [{ value: x.label, tooltip: x.labelTooltip }],
          value: { value: x.value, tooltip: x.valueTooltip },
          type: x?.type,
        })),
      );
    } else {
      out.push({
        labels: batch.map((x) => ({ value: x.label, tooltip: x.labelTooltip })),
        type: batch[0]?.type,
        value: { value: batch[0].value, tooltip: batch[0].valueTooltip },
      });
    }
  }

  return out;
};
